export enum MKBufferType {
    /**
     * Represents the buffered data up until the current playback time.
     */
    BackwardDuration = "backwardduration",

    /**
     * Represents the buffered data starting at the current playback time.
     */
    ForwardDuration = "forwardduration"
}